import React from 'react';

const Button = ({
  children,
  className = '',
  onClick,
  type = 'button',
  disabled = false,
  buttonLink,
  ...props
}) => {
  const baseStyles =
    'bg-black rounded-full w-full text-white font-bold py-9 h-fit hover:bg-black/80 transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black justify-center';

  const finalClassName = `${baseStyles} ${className}`;

  if (buttonLink) {
    return (
      <a
        href={buttonLink}
        className={finalClassName}
        onClick={onClick}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type={type}
      className={finalClassName}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
